import { useAppContext } from "../app-context/use-app-context"
import CircularProgress from "@material-ui/core/CircularProgress"
import { useAuthUserMembership } from "../memberships/hooks/use-auth-user-membership"
import BoardView from "../boards/components/BoardView"
import { getBoardQueryFromContext } from "../context-options/utils"
import ErrorList from "../components/ErrorList"
import { useTranslation } from "react-i18next"
import { useGetBoardV2Query } from "../boards/api/v2"

const queryOptions = { refetchOnMountOrArgChange: true } as const

const KanbanRoute = () => {
  const translations = useTranslations()
  const {
    appContext: { mainContext, subContext },
  } = useAppContext()
  const context = subContext || mainContext
  const query = getBoardQueryFromContext(context)
  const { data: board, isLoading, isError } = useGetBoardV2Query(query, queryOptions)
  const { canCreateTodos } = useAuthUserMembership()

  if (isLoading) return <CircularProgress />
  if (!context || !mainContext) return <ErrorList errors={[translations.contextNotFoundError]} />
  if (isError) return <ErrorList errors={[translations.fetchErrorBoard]} />
  if (!board) return <ErrorList errors={[translations.boardNotFoundError]} />

  const canAddTodos = (mainContext.type === "user" || canCreateTodos) && context.type !== "supplier"

  return <BoardView title={context.name} board={board} canAddTasks={false} canAddTodos={canAddTodos} />
}

const defaultTranslations = {
  contextNotFoundError: "Context not found",
  fetchErrorBoard: "Failed to fetch board",
  boardNotFoundError: "Board not found",
}

const useTranslations = () => {
  const { t } = useTranslation("translation")

  return {
    contextNotFoundError: t("contextNotFoundError", defaultTranslations.contextNotFoundError),
    fetchErrorBoard: t("fetchErrorBoard", defaultTranslations.fetchErrorBoard),
    boardNotFoundError: t("boardNotFoundError", defaultTranslations.boardNotFoundError),
  }
}

export default KanbanRoute
